var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-chart',{attrs:{"force-fit":true,"height":_vm.height,"data":_vm.chartData,"scale":_vm.scale}},[_c('v-tooltip',{attrs:{"htmlContent":_vm.htmlContent}}),_c('v-axis'),_c('v-legend'),_c('v-line',{attrs:{"position":"tradeDate*value","color":"type"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }